import axios from 'axios'
import { DeliverynoteDraftInterface } from 'client/components/DocumentsV1/Deliverynote/DeliverynoteInterface'
import { ReceiptDraftInterface } from 'client/components/DocumentsV1/Receipt/ReceiptInterface'

import { InvoiceListItemInterface } from '../components/invoices/InvoiceListItemInterface'
import { Analytics } from '../Global/Analytics'
import { Events, Modifiers } from '../Global/AnalyticsEvents'
import { DocumentType, DraftInterface } from '../Interfaces/Draft/DraftInterface'
import { EstimateInterface, InvoiceInterface } from '../Interfaces/Invoice/InvoiceInterface'
import { getRequestConfig } from './index'

export async function updateDocumentBaseNumber(type: DocumentType, basenumber: number): Promise<string> {
  Analytics.trackEvent(`${Events.invoiceNumber}:${Modifiers.update}`, { invoiceNumber: basenumber, document: type })
  const response = await axios.put(`/rest-invoice/api/${type}s/number/base`, { basenumber }, getRequestConfig())
  return Promise.resolve(response.data.basenumber.toString())
}

export async function getDocument(
  type: DocumentType,
  documentId: number,
): Promise<InvoiceInterface | EstimateInterface> {
  const response = await axios.get(`/rest-invoice/api/${type}s/${documentId}`, getRequestConfig())
  return response.data as InvoiceInterface | EstimateInterface
}

export async function getDocumentV1<T = DeliverynoteDraftInterface | ReceiptDraftInterface | InvoiceListItemInterface>(
  type: DocumentType,
  documentId: number,
): Promise<T> {
  const response = await axios.get<T>(`/rest-invoice/api/v1/${type}s/${documentId}`, getRequestConfig())
  return response.data
}

export function getDocumentPDFUrl(type: DocumentType, documentId: number): string {
  return `/rest-invoice/api/${type}s/${documentId}/pdf`
}

export function getDocumentV1PDFUrl(type: DocumentType, documentId: number): string {
  return `/rest-invoice/api/v1/${type}s/${documentId}/pdf`
}

export function getConvertedDocumentPDFUrl(type: DocumentType, documentId: number): string {
  return `/rest-invoice/api/v1/invoices/${documentId}/${type}/pdf`
}

export async function getDocumentPDF(type: DocumentType, documentId: number): Promise<any> {
  const config = {
    ...getRequestConfig(),
    responseType: 'blob',
  }
  const response = await axios.get(getDocumentPDFUrl(type, documentId), config)
  return response.data
}

export async function getDocumentPDFV1(type: DocumentType, documentId: number): Promise<any> {
  const config = {
    ...getRequestConfig(),
    responseType: 'blob',
  }
  const response = await axios.get(getDocumentV1PDFUrl(type, documentId), config)
  return response.data
}

export async function getConvertedDocumentPDFV1(type: DocumentType, documentId: number): Promise<any> {
  const config = {
    ...getRequestConfig(),
    responseType: 'blob',
  }
  const response = await axios.get(getConvertedDocumentPDFUrl(type, documentId), config)
  return response.data
}

export async function getDocumentHTML(type: DocumentType, documentId: number): Promise<any> {
  const config = { ...getRequestConfig() }
  const response = await axios.get(`/rest-invoice/api/${type}s/${documentId}/html`, config)
  return response.data
}

export async function getDocumentHTMLV1(type: DocumentType, documentId: number): Promise<any> {
  const config = { ...getRequestConfig() }
  const response = await axios.get(`/rest-invoice/api/v1/${type}s/${documentId}/html`, config)
  return response.data
}

export async function getDraftDocumentHTML(type: DocumentType, documentId: number): Promise<any> {
  const config = { ...getRequestConfig() }
  const response = await axios.get(`/rest-invoice/api/drafts/${type}s/preview/html/${documentId}`, config)
  return response.data
}

export async function getDraftDocumentHTMLV1(type: DocumentType, documentId: number): Promise<any> {
  const config = { ...getRequestConfig() }
  const response = await axios.get(`/rest-invoice/api/v1/drafts/${type}s/preview/html/${documentId}`, config)
  return response.data
}

export async function deleteDocumentV1(type: DocumentType, documentId: number): Promise<any> {
  const config = { ...getRequestConfig() }
  const response = await axios.delete(`/rest-invoice/api/v1/${type}s/${documentId}`, config)
  return response.data
}
